const RECORDING_KEYWORD_REGEX =
  /\s*[&·,\/|()\-\u2212]*\s*녹음(?:하[가-힣]{0,2}|해[가-힣]{0,3})?(?=[\s()·,\/|&\-\u2212!?.:~]|$)/gi;

const sanitize = (raw?: string | null): string => {
  if (!raw || typeof raw !== 'string') {
    return '';
  }

  let text = raw.replace(RECORDING_KEYWORD_REGEX, ' ');

  text = text
    .replace(/\s+/g, ' ')
    .trim();

  text = text
    .replace(/^[&·,\/|()\-\s]+/, '')
    .replace(/[&·,\/|()\-\s]+$/, '')
    .trim();

  text = text
    .replace(/\(\s*\)/g, '')
    .replace(/\[\s*\]/g, '')
    .trim();

  return text;
};

export const getStudentActivityTitle = (
  primaryTitle?: string | null,
  fallbackTitle?: string
): string => {
  const sanitizedPrimary = sanitize(primaryTitle);
  if (sanitizedPrimary) {
    return sanitizedPrimary;
  }

  const sanitizedFallback = sanitize(fallbackTitle);
  if (sanitizedFallback) {
    return sanitizedFallback;
  }

  return '';
};

